import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data";
import { Reveal } from "./Reveal";

const ServiceGrid = ({ title = "Security services", linkPrefix = "/services", context = "" }) => (
  <div className="grid gap-px border border-[#1C2027] bg-[#1C2027] sm:grid-cols-2 lg:grid-cols-3" data-testid="service-grid">
    {SERVICES.map((s, i) => (
      <Reveal key={s.slug} delay={(i % 3) * 0.08} y={16} className="h-full">
        <Link
          to={`${linkPrefix}/${s.slug}`}
          data-testid={`service-card-${s.slug}`}
          className="group flex h-full flex-col justify-between bg-[#10131A] p-6 transition-colors duration-300 hover:bg-[#161A22]"
        >
          <div>
            <div className="flex items-start justify-between">
              <span className="font-condensed text-sm font-bold text-[#F5A800]">{String(i + 1).padStart(2, "0")}</span>
              <ArrowUpRight className="h-4 w-4 text-white/30 transition-all duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-[#F5A800]" />
            </div>
            <h3 className="font-condensed mt-3 text-xl font-bold uppercase leading-tight tracking-wide text-white transition-colors duration-300 group-hover:text-[#F5A800]">
              {s.name}{context ? ` ${context}` : ""}
            </h3>
            <p className="mt-2 text-[13px] leading-relaxed text-[#9BA1AB]">{s.short}</p>
          </div>
          <span className="mt-5 text-[10px] font-bold uppercase tracking-[0.24em] text-white/40 transition-colors duration-300 group-hover:text-[#F5A800]">Intel →</span>
        </Link>
      </Reveal>
    ))}
  </div>
);

export default ServiceGrid;
